import Skeleton from './Skeleton';
import PageSkeleton, { RowListSkeleton } from './PageSkeletons';
import { CampaignHeader } from '../CampaignDetails/CampaignDetails.styles';
import { PendingApprovalStyles } from '../PendingApproval/PendingApproval.styles';

/** The whole page's shape, the campaign picker and Approve button above the list, until the first page has arrived. */
const PendingApprovalsSkeleton = () => (
  <PendingApprovalStyles aria-busy="true">
    <CampaignHeader $noBorder $fixed>
      <div className="select-wrap">
        <Skeleton width={200} height={40} radius="12px" resp />
      </div>
      <Skeleton width={220} height={40} radius="999px" resp />
    </CampaignHeader>
    <PageSkeleton padded={false}>
      <RowListSkeleton count={4} />
    </PageSkeleton>
  </PendingApprovalStyles>
);

export default PendingApprovalsSkeleton;
